// Whether the coach is on for this person (docs/design/AANTAMISVALMENTAJA.md "Optional and per person": Axel on,
// Roosa off; with it off nothing of the coach shows or downloads). The setting itself is work package F's
// (`user.coach` in D1, sent with /api/me like notebookTasks, toggled in coach.settings.tsx); until that lands
// the field is read loosely here, so this package's Asetukset row stays hidden for everyone.
// TODO(WP-F): read UserInfo.coach directly once it is in engine/src/api.ts.
import type { UserInfo } from '@valyrio/engine/api';
import { useApp } from '../state/store';

export const coachOnFor = (me: UserInfo | null | undefined): boolean => (me as (UserInfo & { coach?: unknown }) | null | undefined)?.coach === true;

export function useCoachOn(): boolean {
  return useApp((s) => coachOnFor(s.me));
}
